var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00025 3.99999C8.25625 3.99999 8.51225 4.09799 8.70725 4.29299L13.7073 9.29299C14.0983 9.68399 14.0983 10.316 13.7073 10.707L8.70725 15.707C8.31625 16.098 7.68425 16.098 7.29325 15.707C6.90225 15.316 6.90225 14.684 7.29325 14.293L11.5863 9.99999L7.29325 5.70699C6.90225 5.31599 6.90225 4.684 7.29325 4.293C7.48825 4.098 7.74425 3.99999 8.00025 3.99999",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "aa27bd3bea06c034736ad5b822706263.svg";
export { ForwardRef as ReactComponent };